<template>
  <div class="toolbar-tooltip">
    <component :is="icon" class="toolbar-tooltip-SVG" />
    <span> {{ instructions }} </span>
  </div>
</template>

<script>
export default {
  name: "CreateToolbarInstructionsTooltip",

  props: {
    icon: { required: true },

    instructions: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.toolbar-tooltip {
  position: absolute;
  display: flex;
  min-height: 34px;
  width: fit-content;
  align-items: center;
  justify-content: center;
  border: 0.2px solid #dcdcdd;
  border-radius: 17px;
  background-color: #ffffff;
  color: #515358;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.32);
  padding: 8px 14px;
  bottom: 56px;
  font-size: 12px;
  margin: 0 auto;
  left: 0;
  right: 0;
  pointer-events: none;
  animation-name: tooltipAnimation;
  animation-duration: 7000ms;
  animation-fill-mode: forwards;
}

@keyframes tooltipAnimation {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    display: none;
    opacity: 0;
  }
}

.toolbar-tooltip-SVG {
  width: 18px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Toolbars/CreateObjects/InstructionsTooltip.vue